import React from 'react';
import { useTranslation } from 'react-i18next';
import { ReactComponent as CheckedIcon } from '../../assets/checked.svg';
import './FilterCounter.scss';

type FilterCounterProps = {
  selectedCount: number;
  totalCount: number;
  onReset: () => void;
  isDisabled?: boolean;
};

export const FilterCounter: React.FC<FilterCounterProps> = ({
  selectedCount,
  totalCount,
  onReset,
  isDisabled = false,
}) => {
  const { t } = useTranslation();

  return (
    <div className="filter-counter-container">
      <span className="filter-counter-badge">
        {selectedCount === 0 || selectedCount === totalCount
          ? (<>
          <span className="filter-counter-icon-container">
            <CheckedIcon className="filter-counter-icon" />
          </span>
          {t('All Selected')}
          </>
            
          )
          : selectedCount}
      </span>
      {isDisabled || selectedCount === 0 ? (
        ''
      ) : (
        <div onClick={onReset} className="filter-counter-reset-button">
          {t('Reset')}
        </div>
      )}
    </div>
  );
};
